import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  storeDetails: {
    width: '100%',
    marginTop: 10,
  },
  seperator: theme => ({
    borderBottomWidth: 1,
    borderColor: theme.colors.borderColorFour,
    marginTop: 30,
  }),
  button: {
    width: '100%',
  },
})
